import * as React from "react"
import type { SVGProps } from "react"
const SvgSwatchBook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m3.98 19.8-.85-.35a1.8 1.8 0 0 1-1.04-1.12 2 2 0 0 1 .09-1.58l1.8-3.9zm4 2.2q-.84 0-1.42-.59A2 2 0 0 1 5.98 20v-6l2.64 7.35.16.34q.07.16.2.31zm5.15-.1q-.81.3-1.56-.07c-.75-.37-.85-.65-1.05-1.18L6.07 8.45a2 2 0 0 1 .05-1.56 2 2 0 0 1 1.15-1.04l7.55-2.75q.8-.3 1.55.07c.75.37.85.65 1.05 1.18l4.45 12.2q.3.8-.05 1.56a2 2 0 0 1-1.15 1.04zM10.97 10q.43 0 .72-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.3-.71 1 1 0 0 0-.7-.29 1 1 0 0 0-.72.29 1 1 0 0 0-.28.71q0 .42.28.71.3.3.72.29m1.45 10 7.55-2.75L15.53 5 7.98 7.75z" />
  </svg>
)
export default SvgSwatchBook
